var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-2",on:{"contextmenu":function($event){$event.preventDefault();return _vm.voidFunction.apply(null, arguments)}}},[_c('b-img',{attrs:{"src":require(`@/assets/${_vm.url}`),"height":_vm.maxheight,"fluid":_vm.fluid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }